import { render, staticRenderFns } from "./status-form-step.vue?vue&type=template&id=27d81bfa&scoped=true"
import script from "./status-form-step.vue?vue&type=script&lang=js"
export * from "./status-form-step.vue?vue&type=script&lang=js"
import style0 from "./status-form-step.vue?vue&type=style&index=0&id=27d81bfa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d81bfa",
  null
  
)

export default component.exports